import { Fragment, useState, useEffect } from "react";

import MenuItem from "@mui/material/MenuItem";

import MySelectField from "components/Inputs/MySelectField";
import { httpGetPrices } from "services/http/prices";

const PriceListSelect = (props) => {
  const { value, updateValues } = props;

  const [rows, setRows] = useState();

  useEffect(() => {
    getPrices();
  }, []);

  const getPrices = () => {
    const request = {
      params: {
        // company__id: 1
      },
    };

    httpGetPrices(request).then(
      (response) => {
        setRows(response);
      },
      (_error) => {},
    );
  };

  const handleSelectChange = ({ target }) => {
    updateValues({ [target.name]: target.value });
  };

  return (
    <Fragment>
      <MySelectField
        id="select_price_list"
        name="price_list"
        value={value != null ? value : 0}
        onChange={handleSelectChange}
      >
        {rows
          ? rows.map((row) => (
              <MenuItem key={row.id} value={row.id}>
                {row.name}
              </MenuItem>
            ))
          : null}
      </MySelectField>
    </Fragment>
  );
};

export default PriceListSelect;
